<template>
  <v-container fluid class="intro-container pt-0 pb-0">
    <v-row class="intro-container__row">
      <v-col :cols="7" class="pa-0">
        <intro />
      </v-col>
      <v-col :cols="5">
        <slot />
      </v-col>
    </v-row>
    <niko-footer />
  </v-container>
</template>

<script>
import NikoFooter from "@/components/UI/NikoFooter";
import Intro from "@/components/Intro";

export default {
  name: "intro-container",
  components: {
    NikoFooter,
    Intro,
  },
};
</script>

<style lang="scss">
.intro-container {
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;

  &__row {
    min-height: 500px;
  }
}
</style>
